import type { components } from '@/api'

type ApiPropertyInput = components['schemas']['Projects.PropertyInputResponse']

export function isRawDirectHubInput(
  input: ApiPropertyInput,
): input is components['schemas']['Projects.DirectHubInput'] {
  return 'direct_hub_id' in input
}

export function isRawDirectFieldInput(
  input: ApiPropertyInput,
): input is components['schemas']['Projects.DirectFieldInput'] {
  return 'entity_id' in input && 'property_id' in input
}

export function isRawViaReferenceInput(
  input: ApiPropertyInput,
): input is components['schemas']['Projects.ViaReferencePropertyInput'] {
  return 'via_property_id' in input && 'property_id' in input && !('entity_id' in input)
}

export function isRawRelatedPropertyInput(
  input: ApiPropertyInput,
): input is components['schemas']['Projects.RelatedPropertyInput'] {
  return (
    'property_id' in input &&
    !('entity_id' in input) &&
    !('via_property_id' in input) &&
    !('direct_hub_id' in input)
  )
}
